module.exports = __webpack_public_path__ + "img/4.8cac0caa.png";